export * as documents from './documents'
export * as isAcademic from './is-academic'
export * as shouldAnalyze from './should-analyze'
